<template>
  <div ref="menu">
    <div
      class="dropdown-heading text-white flex flex-row justify-center align-center gap-4"
      @click.prevent="open = !open">
      <div class="text-[16px] font-semibold" :data-test="name + 'link'">
        {{ name }}
      </div>
      <Chevron
        class="self-center transition-transform ease-in-out"
        :class="{ 'rotate-180': open }" />
    </div>
    <div v-show="open">
      <slot name="dropdown-items" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { onClickOutside } from '@vueuse/core'
import Chevron from '@/components/SVGS/Chevron.vue'

interface Props {
  name: string
}

defineProps<Props>()
defineEmits(['change'])

const open = ref(false)
const menu = ref()
const route = useRoute()

onClickOutside(menu, () => {
  if (open.value) open.value = false
})

// Close menu when route changes (navigation completed)
watch(
  () => route.fullPath,
  () => {
    if (open.value) {
      open.value = false
    }
  }
)
</script>
